import { Outlet } from "react-router-dom";

function Root() {
  return (
    <div className="ot-app">
      <div
        id="MainContentArea"
        className="bg-color-primary container pt-6 md:pt-12 pb-6 m-auto"
      >
        <div className="max-w-3xl m-auto flex flex-col">
          <>
            <Outlet />
          </>
        </div>
      </div>
    </div>
  );
}

export default Root;
